import React, { lazy, Suspense } from 'react';
import {connect} from 'react-redux';
import {
  BrowserRouter as Router,
  Redirect,
  withRouter,
  Route
} from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { hasAnyRoleNotExist, setPanelHeight } from "../actions/utils";
import { removeAllCache } from "../actions/actions";
const UserIndex = lazy(() => import('../pages/User/Home/index'));
const GroupList = lazy(() => import('../pages/User/Group/list'));
const GroupCreate = lazy(() => import('../pages/User/Group/create'));
const GroupDetail = lazy(() => import('../pages/User/Group/detail'));
const ReceiverList = lazy(() => import('../pages/User/Receiver/list'));
const ReceiverCreate = lazy(() => import('../pages/User/Receiver/create'));
const ReceiverUpload = lazy(() => import('../pages/User/Receiver/upload'));
const Blacklist = lazy(() => import('../pages/User/Blacklist/list'));
const BlacklistCreate = lazy(() => import('../pages/User/Blacklist/create'));
const BlacklistUpload = lazy(() => import('../pages/User/Blacklist/upload'));
const Blackhour = lazy(() => import('../pages/User/Blackhour/list'));
const SendSms = lazy(() => import('../pages/User/Sms/send'));
const SendSmsSuccess = lazy(() => import('../pages/User/Sms/success'));
const Report = lazy(() => import('../pages/User/Report/list'));
const renderLoader = () => <p>Loading</p>;

class UserLayout extends React.Component {
    constructor(props){
        super(props);
    }

    componentDidMount() {
        setPanelHeight();
        window.addEventListener('load', setPanelHeight);
        window.addEventListener('resize', setPanelHeight);
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', setPanelHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        setPanelHeight();
    }
    
    render() {
        if(localStorage.getItem('user') == null || hasAnyRoleNotExist("Standart"))
        {
            localStorage.removeItem('user');
            localStorage.removeItem('userType');
            this.props.dispatch(removeAllCache());
            return (<Redirect
                        to={{
                            pathname: "/",
                            state: { from: this.props.location }
                        }}
                    />
              );
        }

        return (
            <div>
                <Suspense fallback={renderLoader()}>
                    <Header />
                    <Route exact path="/user" component={UserIndex} />
                    <Route exact path="/user/group/list" component={GroupList} />
                    <Route exact path="/user/group/create" component={GroupCreate} />
                    <Route exact path="/user/group/detail/:id" component={GroupDetail} />
                    <Route exact path="/user/group/detail/:id/receivers" component={ReceiverList} />
                    <Route exact path="/user/group/detail/:id/receivers/create" component={ReceiverCreate} />
                    <Route exact path="/user/group/detail/:id/receivers/upload" component={ReceiverUpload} />
                    <Route exact path="/user/blacklist" component={Blacklist} />
                    <Route exact path="/user/blacklist/create" component={BlacklistCreate} />
                    <Route exact path="/user/blacklist/upload" component={BlacklistUpload} />
                    <Route exact path="/user/blackhour" component={Blackhour} />
                    <Route exact path="/user/sendsms" component={SendSms} />
                    <Route exact path="/user/sendsms/success" component={SendSmsSuccess} />
                    <Route exact path="/user/report" component={Report} />
                    <Footer />
                </Suspense>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}

export default withRouter(connect(mapStateToProps)(UserLayout))